import { MapOverlay } from '@/types/models';
import { DataOverlayEntry } from '@/services/pluginsManager/map/overlays/types/DataOverlayEntry';
import { toPluginCreator } from '@/services/pluginsManager/adapters/toPluginMapOverlay';

export class DataOverlay {
  id: number;

  name: string;

  order: number;

  creatorId: number;

  /** @deprecated use {@link DataOverlay.creatorId} */
  creator: string;

  description: string;

  genomeType: string | null;

  genomeVersion: string | null;

  publicOverlay: boolean;

  type: string;

  entries: DataOverlayEntry[];

  constructor(mapOverlay: MapOverlay) {
    this.id = mapOverlay.id;
    this.name = mapOverlay.name;
    this.order = mapOverlay.order;
    this.creatorId = mapOverlay.creator;
    this.creator = toPluginCreator(mapOverlay.creator);
    this.description = mapOverlay.description;
    this.genomeType = mapOverlay.genomeType;
    this.genomeVersion = mapOverlay.genomeVersion;
    this.publicOverlay = mapOverlay.publicOverlay;
    this.type = mapOverlay.type;
    this.entries = [];
  }

  public addEntry(entry: DataOverlayEntry): void {
    this.entries.push(entry);
  }
}
